/*
 * Module for conversation variables
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/conversationVariables/conversationVariablesView",
  "modules/shared/conversationVariables/conversationVariablesModel",
  "modules/shared/selectableList/selectableListModule",
], function (
  Marionette,
  Messenger,
  ConversationVariablesView,
  ConversationVariablesModel,
  SelectableListModule,
) {
  "use strict";

  const ConversationVariablesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "conversationVariables";
      this.namespace = options.namespace;
      this.region = options.region;
    },
    show: function () {
      this.layout = new ConversationVariablesView.conversationVariablesLayout();
      this.list = this.addSubModule(
        new SelectableListModule({
          region: this.layout.list,
          namespace: this.namespace,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this._setUpView();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    focus: function () {
      if (this.isOpen && this.list) {
        this.list.focus();
      }
    },
    /*
     * Selects the variable in the list with the provided variable Id
     */
    setSelected: function (id) {
      this.convVars.onSynced(function () {
        const variable = this.convVars.get(id);
        if (variable) {
          this.list.selectItem(variable);
        } else {
          this.list.unselectItem();
        }
      }, this);
    },
    _setUpView: function () {
      this.convVars = Messenger.reqres.request("conversation:variables");
      this.list.show(this.convVars);
    },
  });

  return ConversationVariablesController;
});
